//Librerias
import * as THREE from "three";
//Proyecto
import Maqueta from "../Maqueta.js";
import Ambiente from "./Skins/Skin_Color/Ambiente.js";
import Mapa from "./Mapa.js";
import Modelo from "./Modelo.js";
import Materiales from "./Skins/Skin_Color/Materiales.js";

export default class Mundo {
  constructor() {
    this.maqueta = new Maqueta();
    this.escena = this.maqueta.escena;
    this.colores = this.maqueta.colores;
    this.recursos = this.maqueta.recursos;
    this.escalaProyecto = this.maqueta.tamanos.escalaProyecto;
    this.posicionProyecto = this.maqueta.tamanos.posicionProyecto;
    this.posicionTerreno = this.maqueta.tamanos.posicionTerreno;
    this.materiales = new Materiales();
    this.mapa = {};
    this.debug = this.maqueta.debug;

    //Debug
    if (this.debug.active) {
      this.debugColores = this.debug.ui.addFolder("Colores");
      this.debugProyecto = this.debug.ui.addFolder("Proyecto");
      this.debugTerreno = this.debug.ui.addFolder("Terreno");
      this.debugMapa = this.debug.ui.addFolder("Mapa");
    }

    this.grupoMapa = new THREE.Group();
    this.grupoVias = new THREE.Group();
    this.grupoAndenes = new THREE.Group();
    this.grupoManzanas = new THREE.Group();
    this.grupoTransitoFijo = new THREE.Group();
    this.grupoTransito = new THREE.Group();
    this.grupoEdificios = new THREE.Group();
    this.grupoEdificiosBajos = new THREE.Group();
    this.grupoArbolesCoord = new THREE.Group();
    this.grupoArboles = new THREE.Group();
    this.grupoArbolesParticulas = new THREE.Group();
    this.grupoVegetacion = new THREE.Group();
    this.grupoProyecto = new THREE.Group();
    this.mascarasZonas = new THREE.Group();
    this.mascarasProyecto = new THREE.Group();



    // Esperar que cargue Recursos
    this.recursos.on("cargado", () => {
      // Setup
      this.crearTerreno();
      //this.crearMapa()
      //this.crearVegetacion();
      this.crearModelos();
      this.crearZonas();
      this.crearMascaras();
      this.crearNubes();
      this.crearDebug();

      this.ambiente = new Ambiente();
    });
    console.log('Mundo creado')
  }

  crearHelper() {
    const axesHelper = new THREE.AxesHelper(2);
    axesHelper.position.y = 0.02;
    this.escena.add(axesHelper);

    //Test Mesh
    this.bolaHelper = new THREE.Mesh(
      new THREE.SphereGeometry(0.075, 16, 16),
      new THREE.MeshStandardMaterial({ color: this.colores.paleta.color3 })
    );
    this.escena.add(this.bolaHelper);

    //Plano helper
    this.planoHelper = new THREE.Mesh(
      new THREE.PlaneGeometry(10 * 2.025, 10 * 2.41, 10, 10),
      new THREE.MeshStandardMaterial({
        color: this.colores.paleta.color3,
        wireframe: true,
      })
    );
    this.planoHelper.position.set(5.72, 0.11, -5.47);
    this.planoHelper.rotation.x = Math.PI * 0.5;
    //this.planoHelper.rotation.z = Math.PI * 0.3;
    //this.escena.add(this.planoHelper);
  }
  crearTerreno() {
    //Satelital
    this.satelital = new THREE.Mesh(
      new THREE.CircleGeometry(100, 32),
      this.materiales.materialesContexto.satelital
    );
    this.satelital.receiveShadow = true;
    this.satelital.rotation.x = Math.PI * 0.5;

    this.satelital.position.set(
      this.posicionTerreno.x,
      this.posicionTerreno.y - 0.15,
      this.posicionTerreno.z
    );

    this.escena.add(this.satelital);

    /*const floor = new THREE.Mesh(
      new THREE.PlaneGeometry(100, 100),
      this.materiales.materialesContexto.satelitalZoom);
    floor.receiveShadow = true;
    floor.position.set(-0.2, -0.2, -0.3);
    floor.rotation.x = -Math.PI * 0.5;
    //floor.rotation.z = Math.PI * 0.255;
    floor.scale.set(1.55, 1.55, 1.55) */




    //

    /*this.satelitalZoom = new THREE.Mesh(
      new THREE.CircleGeometry(155 * 0.5, 32),
      this.materiales.materialesContexto.satelitalZoom
    );
    this.satelitalZoom.receiveShadow = true;
    this.satelitalZoom.rotation.x = Math.PI * 0.5;
    this.satelitalZoom.rotation.z = -0.79 /*Math.PI * 0.255*/;

    /*this.satelitalZoom.position.set(
      this.posicionTerreno.x,
      this.posicionTerreno.y,
      this.posicionTerreno.z
    );

    this.escena.add(this.satelitalZoom );*/

    //Terreno con elevacion
    this.elevacion = new THREE.Mesh(
      new THREE.PlaneGeometry(325, 325, 60, 60),
      this.materiales.materialesContexto.elevacion
    );
    this.elevacion.rotation.x = -Math.PI * 0.5;
    this.elevacion.rotation.z = Math.PI * -0.5;
    this.elevacion.position.y = -3;
    this.escena.add(this.elevacion);

    //Pasto base

    //this.escena.add(this.pastoBase);
  }
  crearModelos() {
    const modelos = [
      //Proyecto

      /*{
        modeloRuta: this.recursos.items.modelo_torre_3,
        materialRuta: this.recursos.items.text_torre_3,
        materialRutaAlpha: null,
        nombre: 'torre_3'
      },*/

      //Torre 1
      {
        modeloRuta: this.recursos.items.modelo_torre_1,
        materialRuta: this.recursos.items.text_torre_1,
        materialRutaAlpha: null,
        nombre: 'torre_1'
      },
      {
        modeloRuta: this.recursos.items.modelo_torre_1_p1,
        materialRuta: this.recursos.items.text_torre_1_p1,
        materialRutaAlpha: null,
        nombre: 'torre_1_p1'
      },
      {
        modeloRuta: this.recursos.items.modelo_torre_1_pisos,
        materialRuta: this.recursos.items.text_torre_1_pisos,
        materialRutaAlpha: null,
        nombre: 'torre_1_pisos'
      },
      {
        modeloRuta: this.recursos.items.modelo_torre_1_ventanas,
        materialRuta: this.recursos.items.text_torre_1_ventanas,
        materialRutaAlpha: null,
        nombre: 'torre_1_ventanas'
      },
      {
        modeloRuta: this.recursos.items.modelo_torre_1_balconesMuros,
        materialRuta: this.recursos.items.text_torre_1_balconesMuros,
        materialRutaAlpha: null,
        nombre: 'torre_1_balconesMuros'
      },
      {
        modeloRuta: this.recursos.items.modelo_torre_1_balconesBarandas,
        materialRuta: this.recursos.items.text_torre_1_balconesBarandas,
        materialRutaAlpha: this.recursos.items.text_torre_1_balconesBarandas_alpha,
        nombre: 'torre_1_balconesBarandas'
      },

      //Torre 2
      {
        modeloRuta: this.recursos.items.modelo_torre_2,
        materialRuta: this.recursos.items.text_torre_2,
        materialRutaAlpha: null,
        nombre: 'torre_2'
      },
      {
        modeloRuta: this.recursos.items.modelo_torre_2_p1,
        materialRuta: this.recursos.items.text_torre_2_p1,
        materialRutaAlpha: null,
        nombre: 'torre_2_p1'
      },
      {
        modeloRuta: this.recursos.items.modelo_torre_2_pisos,
        materialRuta: this.recursos.items.text_torre_2_pisos,
        materialRutaAlpha: null,
        nombre: 'torre_2_pisos'
      },
      {
        modeloRuta: this.recursos.items.modelo_torre_2_ventanas,
        materialRuta: this.recursos.items.text_torre_2_ventanas,
        materialRutaAlpha: null,
        nombre: 'torre_2_ventanas'
      },
      {
        modeloRuta: this.recursos.items.modelo_torre_2_balconesMuros,
        materialRuta: this.recursos.items.text_torre_2_balconesMuros,
        materialRutaAlpha: null,
        nombre: 'torre_2_balconesMuros'
      },
      {
        modeloRuta: this.recursos.items.modelo_torre_2_balconesBarandas,
        materialRuta: this.recursos.items.text_torre_2_balconesBarandas,
        materialRutaAlpha: this.recursos.items.text_torre_2_balconesBarandas_alpha,
        nombre: 'torre_2_balconesBarandas'
      },

      //Contexto
      /*{
        modeloRuta: this.recursos.items.modelo_arcos_futbol,
        materialRuta: this.recursos.items.text_arcos_futbol,
        materialRutaAlpha: this.recursos.items.text_arcos_futbol_alpha,
        nombre: 'arcos_futbol'
      },*/

      // carros
      // cerramientoUrbanismo * no se usa
      // comunal
      // duplicadores
      // urbanismoSauces
      // urbanismoFelicidad
      // vegetacionFelicidad

      //fondoMapa

      //rampaAccesoVehicular*
      //pastoInterior
      //contexto1
      //contexto2
      //anden
      //adoquinContexto1
      //adoquinContexto2
      //adoquinUrbanismo
      //cerramientoConjunto*
      {
        modeloRuta: this.recursos.items.modelo_carros,
        materialRuta: this.recursos.items.text_carros,
        materialRutaAlpha: null,
        nombre: 'carros'
      },
      {
        modeloRuta: this.recursos.items.modelo_comunal,
        materialRuta: this.recursos.items.text_comunal,
        materialRutaAlpha: null,
        nombre: 'comunal'
      },
      {
        modeloRuta: this.recursos.items.modelo_duplicadores,
        materialRuta: this.recursos.items.text_duplicadores,
        materialRutaAlpha: null,
        nombre: 'duplicadores'
      },
      {
        modeloRuta: this.recursos.items.modelo_urbanismoSauces,
        materialRuta: this.recursos.items.text_urbanismoSauces,
        materialRutaAlpha: null,
        nombre: 'urbanismoSauces'
      },
      {
        modeloRuta: this.recursos.items.modelo_urbanismoFelicidad,
        materialRuta: this.recursos.items.text_urbanismoFelicidad,
        materialRutaAlpha: null,
        nombre: 'urbanismoFelicidad'
      },
      {
        modeloRuta: this.recursos.items.modelo_vegetacionFelicidad,
        materialRuta: this.recursos.items.text_vegetacionFelicidad,
        materialRutaAlpha: null,
        nombre: 'vegetacionFelicidad'
      },
      /*{
        modeloRuta: this.recursos.items.modelo_cerramientoUrbanismo,
        materialRuta: this.recursos.items.text_cerramientoUrbanismo,
        materialRutaAlpha: this.recursos.items.text_cerramientoUrbanismo_alpha,
        nombre: 'cerramientoUrbanismo'
      },*/
      {
        modeloRuta: this.recursos.items.modelo_fondoMapa,
        materialRuta: this.recursos.items.text_fondoMapa,
        materialRutaAlpha: null,
        nombre: 'fondoMapa'
      },

      {
        modeloRuta: this.recursos.items.modelo_rampaAccesoVehicular,
        materialRuta: this.recursos.items.text_rampaAccesoVehicular,
        materialRutaAlpha: this.recursos.items.text_rampaAccesoVehicular_alpha,
        nombre: 'rampaAccesoVehicular'
      },
      {
        modeloRuta: this.recursos.items.modelo_pastoInterior,
        materialRuta: this.recursos.items.text_pastoInterior,
        materialRutaAlpha: null,
        nombre: 'pastoInterior'
      },
      {
        modeloRuta: this.recursos.items.modelo_contexto1,
        materialRuta: this.recursos.items.text_contexto1,
        materialRutaAlpha: null,
        nombre: 'contexto1'
      },
      {
        modeloRuta: this.recursos.items.modelo_contexto2,
        materialRuta: this.recursos.items.text_contexto2,
        materialRutaAlpha: null,
        nombre: 'contexto2'
      },
      {
        modeloRuta: this.recursos.items.modelo_anden,
        materialRuta: this.recursos.items.text_anden,
        materialRutaAlpha: null,
        nombre: 'anden'
      },
      {
        modeloRuta: this.recursos.items.modelo_adoquinContexto1,
        materialRuta: this.recursos.items.text_adoquinContexto1,
        materialRutaAlpha: null,
        nombre: 'adoquinContexto1'
      },
      {
        modeloRuta: this.recursos.items.modelo_adoquinContexto2,
        materialRuta: this.recursos.items.text_adoquinContexto2,
        materialRutaAlpha: null,
        nombre: 'adoquinContexto2'
      },
      {
        modeloRuta: this.recursos.items.modelo_adoquinUrbanismo,
        materialRuta: this.recursos.items.text_adoquinUrbanismo,
        materialRutaAlpha: null,
        nombre: 'adoquinUrbanismo'
      },
      {
        modeloRuta: this.recursos.items.modelo_cerramientoConjunto,
        materialRuta: this.recursos.items.text_cerramientoConjunto,
        materialRutaAlpha: null,
        nombre: 'cerramientoConjunto'
      },


    ];



    //
    modelos.forEach(({ modeloRuta, materialRuta, materialRutaAlpha, nombre, opacidad }) => {
      if (!modeloRuta) {
        
        console.log('Error con:', nombre)

      } else {
        this[nombre] = modeloRuta.scene;

        const material = new THREE.MeshStandardMaterial({
          map: materialRuta,
        });

        if (materialRutaAlpha) {
          material.transparent = true;
          material.alphaMap = materialRutaAlpha;
          material.side = THREE.DoubleSide;

        }

        if (opacidad) {
          material.transparent = true;
          material.opacity = .4
          material.side = THREE.DoubleSide;
        }
        this[nombre].traverse((child) => {
          child.material = material;
        });
        this.grupoProyecto.add(this[nombre]);

        if(this.debug.active) {
          this.debugProyecto
        .add(this[nombre].position, "y")
        .min(-2)
        .max(2)
        .step(0.01)
        .name(`${nombre} Y`);
        }
      }
    });

    //Crear elementos con linea   

    this.edificios_vecinos = new Modelo(
      this.recursos.items.modelo_edificiosVecinos,
      this.materiales.materialesProyecto.edificiosVecinos,
      this.grupoProyecto,
      true,
      false
    )

    console.log(this.fondoMapa.position)
    this.fondoMapa.position.y = -0.05
    this.pastoInterior.position.y = 0.05

    //Vías

    /*this.vias = new Modelo(
      this.recursos.items.vias,
      this.materiales.materialesContexto.vias,
      this.grupoProyecto,
      false,
      false
    )

   this.vias.modelo.visible = false    */

    //Configurar modelos
    this.grupoProyecto.scale.set(
      this.escalaProyecto.x,
      this.escalaProyecto.y,
      this.escalaProyecto.z
    );
    this.grupoProyecto.position.set(
      this.posicionProyecto.x,
      this.posicionProyecto.y,
      this.posicionProyecto.z
    );
    //this.grupoProyecto.rotation.y = -0.9//Math.PI * -0.3;

    if (this.debug.active) {
      this.debugProyecto
        .add(this.grupoProyecto.position, "x")
        .min(-10)
        .max(10)
        .step(0.01)
        .name("Proyecto x");
      this.debugProyecto
        .add(this.grupoProyecto.position, "y")
        .min(-10)
        .max(10)
        .step(0.01)
        .name("Proyecto y");
      this.debugProyecto
        .add(this.grupoProyecto.position, "z")
        .min(-10)
        .max(10)
        .step(0.01)
        .name("Proyecto z");

      this.debugProyecto
        .add(this.grupoProyecto.rotation, "y")
        .min(-10)
        .max(10)
        .step(0.01)
        .name("Proyecto Rot y");
    }
    this.escena.add(this.grupoProyecto);
  }
  crearZonas() {

    this.recursos.items.mascarasZonas.scene.traverse((child) => {

      if (child.type === 'Mesh') {
        child.material = this.materiales.materialesProyecto.mascarasZonas
        child.visible = false
        child.userData.activo = false
        console.log(child)
      }

    });

    this.mascarasZonas.add(this.recursos.items.mascarasZonas.scene)

    //escalar
    this.mascarasZonas.scale.set(
      this.escalaProyecto.x,
      this.escalaProyecto.y,
      this.escalaProyecto.z
    );
    this.mascarasZonas.position.set(
      this.posicionProyecto.x,
      this.posicionProyecto.y,
      this.posicionProyecto.z
    );

    this.escena.add(this.mascarasZonas);
  }
  crearMascaras() {
    this.mascarasProyecto.scale.set(
      this.escalaProyecto.x,
      this.escalaProyecto.y,
      this.escalaProyecto.z
    );
    this.mascarasProyecto.position.set(
      this.posicionProyecto.x,
      this.posicionProyecto.y,
      this.posicionProyecto.z
    );
    //this.mascarasProyecto.rotation.y = -0.9;
    this.escena.add(this.mascarasProyecto);

  }
  crearNubes() {
    const geometria = new THREE.SphereGeometry(200, 32, 32),
      texturaNubes = this.recursos.items.textura_nubes;

    texturaNubes.wrapS = THREE.RepeatWrapping;
    texturaNubes.wrapT = THREE.RepeatWrapping;
    texturaNubes.repeat.set(2, 4);

    const materialNubes = new THREE.MeshStandardMaterial({
      fog: false,
      side: THREE.BackSide,
      transparent: true,
      map: texturaNubes,
      alphaMap: texturaNubes,
    });

    const esferaNubes = new THREE.Mesh(geometria, materialNubes);

    // Añadir la malla a la escena
    this.escena.add(esferaNubes);
  }

  crearDebug() {
    if (this.debug.active) {
      //Helper
      this.crearHelper();
      this.debugProyecto
        .add(this.bolaHelper.position, "x")
        .min(-50)
        .max(50)
        .step(0.01)
        .name("Helper x");
      this.debugProyecto
        .add(this.bolaHelper.position, "y")
        .min(-50)
        .max(50)
        .step(0.01)
        .name("Helper y");
      this.debugProyecto
        .add(this.bolaHelper.position, "z")
        .min(-50)
        .max(50)
        .step(0.01)
        .name("Helper z");      

      this.debugProyecto
        .add(this.escalaProyecto, "x")
        .min(0.01)
        .max(0.1)
        .step(0.01)
        .name("Proyecto scale x");
      this.debugProyecto
        .add(this.escalaProyecto, "y")
        .min(0.01)
        .max(0.1)
        .step(0.01)
        .name("Proyecto scale y");
      this.debugProyecto
        .add(this.escalaProyecto, "z")
        .min(0.01)
        .max(0.1)
        .step(0.01)
        .name("Proyecto scale z");

      

      this.debugMapa
        .add(this.grupoMapa.position, "x")
        .min(-100)
        .max(100)
        .step(0.001)
        .name("Mapa x");
      this.debugMapa
        .add(this.grupoMapa.position, "y")
        .min(-100)
        .max(100)
        .step(0.001)
        .name("Mapa y");
      this.debugMapa
        .add(this.grupoMapa.position, "z")
        .min(-100)
        .max(100)
        .step(0.001)
        .name("Mapa z");
           

      this.debugProyecto
        .add(this.mascarasZonas.position, "x")
        .min(-5)
        .max(5)
        .step(0.001)
        .name("Zonas Comunes x");

      this.debugProyecto
        .add(this.mascarasZonas.position, "y")
        .min(-5)
        .max(5)
        .step(0.001)
        .name("Zonas Comunes y");

      this.debugProyecto
        .add(this.mascarasZonas.position, "z")
        .min(-5)
        .max(5)
        .step(0.001)
        .name("Zonas Comunes z");


      this.debugProyecto
        .add(this.mascarasZonas.rotation, "y")
        .min(-15)
        .max(15)
        .step(0.01)
        .name("Zonas Comunes ry");

      //Colores

      this.debugColores
        .addColor(this.colores.coloresMundo, "colorEdificios")
        .onChange(() => {
          this.materiales.materialesProyecto.edificiosVecinos.color.set(
            this.colores.coloresMundo.colorEdificios
          );
        })
        .name("Edificios");

      this.debugColores
        .addColor(this.colores.coloresMundo, "colorTerreno")
        .onChange(() => {
          this.materiales.materialesContexto.elevacion.color.set(
            this.colores.coloresMundo.colorTerreno
          );
          this.materiales.materialesContexto.manzanas.color.set(
            this.colores.coloresMundo.colorTerreno
          );
        })
        .name("Terreno");

      this.debugColores
        .addColor(this.colores.coloresMundo, "colorNubes")
        .onChange(() => {
          this.materiales.materialesContexto.nubes.color.set(
            this.colores.coloresMundo.colorNubes
          );
        })
        .name("Nubes");
    }
  }
}
